module.exports = new __parcel__URL__("smallStar.acdc2e92.svg").toString();